<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-sm-12 col-md-8 col-lg-6">
      <!-- REPORT TITLE  -->
      <h2 class="mb-3">{{'reportsWizard.header.reportOf' | translate }} {{report.reportData.name}}</h2>

      <!-- GO BACK BUTTON -->
      <button type="button" class="btn btn-secondary mb-3" (click)="goBack()">
        <i class="pi pi-arrow-left"></i>
        {{ 'reportsWizard.reportsForm.goBack' | translate }}
      </button>

      <!-- FORM -->
      <form [formGroup]="reportForm" (ngSubmit)="onSubmit()" class="p-3 border rounded">
        <!-- Billing Account Field -->
        @if (!isDelegationUser) {
          <div class="mb-3">
            <label for="billingAccount">{{'tableManagement.companies.company' | translate}}</label>
            <p-multiSelect [options]="billingAccounts" [(ngModel)]="selectedBillingAccounts"
              formControlName="billingAccount" optionLabel="codeName" class="ms-3" [virtualScroll]="true"
              itemSize="30" [panelStyle]="{'min-width': '350px'}"
              placeholder="{{'general.select' | translate}} {{'tableManagement.companies.company' | translate}}"
              [showClear]="true">
              <ng-template let-item pTemplate="option">
                <div class="billing-account-option">
                  ({{ item.code }}) {{ item.name }}
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        }

        <!-- Division Field -->
        @if (!isDelegationUser) {
          <div class="p-field">
            <label for="division">{{'tableManagement.divisions.division' | translate}}</label>
            <p-multiSelect [options]="divisions" [(ngModel)]="selectedDivisions" formControlName="division"
              optionLabel="codeName" class="ms-3"
              placeholder="{{'general.select' | translate}} {{'tableManagement.divisions.division' | translate}}"
              [showClear]="true">
              <ng-template let-item pTemplate="option">
                <div class="delegation-option">
                  ({{ item.code }}) {{ item.name }}
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        }

        <!-- Subdivision Field -->
        @if (!isDelegationUser) {
          <div class="p-field">
            <label for="subdivision">{{'tableManagement.subdivisions.subdivision' | translate}}</label>
            <p-multiSelect [options]="subdivisions" [(ngModel)]="selectedSubdivisions"
              formControlName="subdivision" optionLabel="name" class="ms-3"
              placeholder="{{'general.select' | translate}} {{'tableManagement.subdivisions.subdivision' | translate}}"
              [showClear]="true">
              <ng-template let-item pTemplate="option">
                <div class="delegation-option">
                  ({{ item.code }}) {{ item.name }}
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        }

        <!-- Parameters Field (DNI or License) -->
        <div class="p-field-radiobutton">
          <div class="p-formgroup-inline">
            <p-radioButton name="parameters" value="DNI" inputId="paramDNI" formControlName="parameters"></p-radioButton>
            <label for="paramDNI" class="ms-1" style="cursor:pointer">{{ 'drivers.form.nif' | translate }}</label>
            <p-radioButton name="parameters" value="license" inputId="paramLicense" formControlName="parameters" class="ms-3"></p-radioButton>
            <label for="paramLicense" class="ms-1" style="cursor:pointer">{{ 'documents.type.LICENSE' | translate }}</label>
          </div>
        </div>
      </form>

      <!-- SUBMIT BUTTON -->
      <button type="submit" pButton (click)="toPhase3()"
        [disabled]="!reportForm.valid"
        class="btn btn-primary mt-3 w-100"
      [ngStyle]="{'background-color': '#C42C22', 'border-color': '#C42C22'}">{{ 'reportsWizard.reportsForm.next' | translate }}</button>
    </div>
  </div>
</div>